import { Link } from 'react-router-dom';
import { useOrders } from '@/hooks/useOrders';
import { ListSkeleton } from '@/components/ui/SkeletonLoader';
import { OrderCard } from '@/components/orders/OrderCard';
import { Button } from '@/components/ui/Button';

export const OrdersPage = () => {
  const { data, isLoading, error } = useOrders();

  return (
    <div
      className="container-main"
      style={{
        maxWidth: '896px',
        paddingTop: 'var(--space-12)',
        paddingBottom: 'var(--space-12)',
      }}
    >
      <div
        className="flex items-center justify-between"
        style={{ marginBottom: 'var(--space-8)' }}
      >
        <h1
          style={{
            fontSize: 'var(--text-3xl)',
            fontWeight: 'var(--font-weight-bold)',
            color: 'var(--text-primary)',
            letterSpacing: 'var(--tracking-tight)',
          }}
        >
          My Orders
        </h1>
        <Link to="/quote">
          <Button>New Quote</Button>
        </Link>
      </div>

      {isLoading && <ListSkeleton />}

      {error && (
        <div
          className="text-center"
          style={{
            padding: 'var(--space-8)',
            color: 'var(--color-error-500)',
            fontSize: 'var(--text-sm)',
          }}
        >
          Failed to load orders. Please try again.
        </div>
      )}

      {data && data.data.length === 0 && (
        <div
          className="text-center"
          style={{
            borderRadius: 'var(--radius-lg)',
            border: '1px solid var(--border-default)',
            backgroundColor: 'var(--bg-surface)',
            paddingTop: 'var(--space-16)',
            paddingBottom: 'var(--space-16)',
          }}
        >
          <p style={{ color: 'var(--text-tertiary)' }}>No orders yet.</p>
          <Link
            to="/catalog"
            style={{
              marginTop: 'var(--space-2)',
              display: 'inline-block',
              color: 'var(--text-accent)',
              textDecoration: 'none',
            }}
          >
            Browse the catalog or upload a 3D model to get started
          </Link>
        </div>
      )}

      {data && data.data.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
          {data.data.map((order) => (
            <OrderCard key={order.orderId} order={order} />
          ))}
        </div>
      )}
    </div>
  );
};
